import { Box } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import cn from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { RegisterOptions, UseFormRegister } from 'react-hook-form';

import styles from './styles.module.scss';

interface InputProps {
  wrapperClassName?: string;
  inputClass?: string;
  register?: UseFormRegister<any>;
  registerOptions?: RegisterOptions;
  errors?: { [key: string]: any };
  wrapperStyle?: React.CSSProperties;
  name: string;
  label?: string;
  onChange?: any;
  disabled?: boolean;
  autoComplete?: string;
  value?: any;
  required?: boolean;
}

const DateTextField: React.FC<InputProps> = ({
  wrapperClassName,
  inputClass,
  wrapperStyle,
  name,
  register,
  registerOptions,
  errors,
  label,
  onChange,
  disabled = false,
  autoComplete,
  value,
  required,
  ...props
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (errors && name) {
      const nameArray = name.split('.');
      const error = nameArray.length > 1 ? errors[nameArray[0]]?.[nameArray[1]]?.message : errors[name]?.message;
      setErrorMessage(error || '');
    } else {
      setErrorMessage('');
    }
  }, [errors, name]);

  return (
    <Box className={cn(styles.inputWrapper, wrapperClassName)} style={wrapperStyle}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer
          components={['DatePicker']}
          sx={{
            paddingTop: '6px',
            height: '112%',
            marginTop: '-6px',
          }}
        >
          <DatePicker
            className={cn(styles.input, inputClass)}
            {...(register ? register(name, registerOptions) : {})}
            inputRef={inputRef}
            label={
              <span className={styles.labelWithAsterisk}>
                {label} {required && <span className={styles.required}>*</span>}
              </span>
            }
            slotProps={{
              textField: {
                error: !!errorMessage,
                helperText: errorMessage,
              },
            }}
            disabled={disabled}
            onChange={onChange}
            value={value}
            {...props}
          />
        </DemoContainer>
      </LocalizationProvider>
    </Box>
  );
};

export default DateTextField;
